// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29hj7","right":"styles_right__3lPAC"};